<template>
    <Modal @cancel="cancel">
        <div class="success-container">
            <img class="icon" :src="getSuccessImg()" alt="success">
            <img v-if="optionalImage" class="optional-image" :src="optionalImage" alt="optional">
            <p>
                {{ title }}
            </p>
            <p class="pre-line">
                {{ subtitle }}
            </p>
            <img class="close-icon" v-on:click="cancel" :src="closeIcon" alt="close" />
        </div>
    </Modal>
</template>

<script lang='ts'>
import { defineComponent } from 'vue';
import Modal from './Modal.vue';

export default defineComponent({
    components: { Modal },
    methods: {
        getSuccessImg() {
            return require('@/assets/img/valid2.svg');
        },
        cancel(){
            this.$emit('cancel');
        }
    },
    computed: {
        closeIcon() {
            return require('@/assets/img/close-black.svg');
        },
    },
    props: {
        title: {type: String, required: true},
        subtitle: {type: String, required: true},
        optionalImage: { type: String, required: false }
    }
});
</script>

<style scoped>
.pre-line{
    white-space: pre-line;
}
.icon{
    margin: 0;
}
.close-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
}
.success-container{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 375px;
    background-color: var(--white);
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14),
    0px 1px 5px rgba(0, 0, 0, 0.12);
    text-align: center;
    font-weight: 500;
    font-size: var(--font-size-low-medium);
    color: var(--color-principal);
    padding: 16px;
    gap: 8px;
}
button{
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-normal);
    width: 95px;
    height: 100%;
    border-radius: 6px;
    border-width: 1px;
    border-style: solid;
    cursor: pointer;

}
.button-confirm{
    background-color: var(--color-principal);
    color: var(--white);
    border: none;
    height: 36px;
}
.optional-image {
    max-width: 100%;
    height: auto;
    margin-top: 10px;
    object-fit: contain;
}
</style>
